import {LitElement, css, html, PropertyValues, unsafeCSS} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {property} from 'lit/decorators/property.js';
import {styleMap} from "lit/directives/style-map.js";
import {classMap} from "lit/directives/class-map.js";
import cssScheme from  '../../../themes/benefact-trust/colours.scss?inline';

export interface BgQuatroInterface {
  color: string,
  colorScheme: string,
  size: number,
}

/**
 * An example element.
 *
 * @slot - This element has a slot
 * @csspart button - The button
 */
@customElement('bg-quatro')
export class BgQuatro extends LitElement {

  constructor(args:BgQuatroInterface) {
    super();
    if(!args) {
      return
    };
    this.size = args.size;
    this.color = args.color;
    this.colorScheme = args.colorScheme;
  }

  @property()
  docsHint = '';
    
  @property({ type: Number })
  size = 200;
    
  @property({ type: String })
  color = "";
  
  @property({ type: String, attribute: 'color-scheme' })
  colorScheme = "";

  render() {
    var styleList = {"--st-color":this.color, "--st-height": + this.size + "px)", "--st-width":"var(" + this.size + "px)"}
    var ctaClasses = {
      "canvas": true,
      "bg-color-scheme-dark-green" : this.colorScheme === "dark-green"
    }
    return html`
      <div class="${classMap(ctaClasses)}" style="${styleMap(styleList)}" part="base">
        <div class="quatro-out"></div>
        <div class="quatro-inner">
          <slot></slot>
        </div>
      </div>
      <div class="svg">
      <svg>
        <clipPath id="qutro" clipPathUnits="objectBoundingBox"><path d="M0.436,0.998 C0.386,0.987,0.325,0.954,0.286,0.917 C0.262,0.893,0.243,0.868,0.223,0.829 C0.206,0.796,0.206,0.796,0.179,0.783 C0.068,0.73,0,0.624,0,0.504 C0,0.382,0.073,0.269,0.183,0.221 C0.205,0.211,0.208,0.209,0.214,0.193 C0.221,0.172,0.251,0.125,0.272,0.101 C0.307,0.062,0.367,0.027,0.426,0.011 C0.467,0,0.531,0,0.573,0.011 C0.646,0.031,0.705,0.07,0.749,0.129 C0.766,0.152,0.79,0.197,0.79,0.206 C0.79,0.208,0.8,0.214,0.811,0.219 C0.866,0.242,0.924,0.294,0.956,0.346 C0.989,0.401,1,0.477,0.998,0.536 C0.984,0.642,0.923,0.73,0.831,0.777 L0.792,0.797,0.777,0.828 C0.758,0.866,0.737,0.893,0.71,0.919 C0.67,0.957,0.613,0.987,0.56,0.998 C0.529,1,0.467,1,0.436,0.998"></path></clipPath> 
        <clipPath id="quatroOut" clipPathUnits="objectBoundingBox"><path d="M0.4585,0.998 c-0.106,-0.013,-0.194,-0.077,-0.24,-0.174 l-0.014,-0.03,-0.036,-0.018 c-0.079,-0.039,-0.131,-0.101,-0.158,-0.188 c-0.011,-0.036,-0.014,-0.109,-0.006,-0.151 c0.02,-0.098,0.09,-0.185,0.18,-0.221 c0.019,-0.008,0.02,-0.009,0.036,-0.042 c0.047,-0.097,0.133,-0.158,0.243,-0.172 c0.133,-0.017,0.267,0.06,0.32,0.181 c0.01,0.023,0.011,0.025,0.031,0.033 c0.067,0.027,0.125,0.084,0.158,0.153 c0.02,0.044,0.027,0.077,0.028,0.129 c0,0.051,-0.005,0.079,-0.025,0.125 c-0.031,0.073,-0.088,0.129,-0.161,0.16 c-0.019,0.008,-0.021,0.01,-0.029,0.03 c-0.053,0.125,-0.186,0.2,-0.325,0.183 m0.09,-0.033 c0.05,-0.009,0.104,-0.037,0.143,-0.074 c0.027,-0.026,0.046,-0.052,0.063,-0.088 l0.015,-0.03,0.037,-0.019 c0.089,-0.044,0.145,-0.124,0.159,-0.225 c0.01,-0.074,-0.02,-0.161,-0.076,-0.221 c-0.028,-0.03,-0.048,-0.044,-0.087,-0.066 l-0.03,-0.016,-0.016,-0.032 c-0.009,-0.018,-0.02,-0.038,-0.026,-0.045 c-0.105,-0.14,-0.301,-0.159,-0.426,-0.041 c-0.03,0.029,-0.043,0.046,-0.065,0.089 c-0.016,0.032,-0.017,0.033,-0.038,0.041 c-0.061,0.024,-0.115,0.079,-0.146,0.147 c-0.042,0.092,-0.031,0.196,0.028,0.28 c0.03,0.042,0.083,0.084,0.127,0.099 c0.016,0.006,0.018,0.008,0.027,0.03 c0.036,0.085,0.115,0.151,0.204,0.17 c0.028,0.006,0.078,0.007,0.107,0.001"></path></clipPath> 
      </svg>
      </div>
    `
  }
  protected updated(changed: PropertyValues): void {
    if (changed.has("size") && !!this.size) {
      this.style.setProperty("--st-height", this.size.toString()+"px");
      this.style.setProperty("--st-width", this.size.toString()+"px");
    }

  }
  static styles = [unsafeCSS(cssScheme),
    css`
    .svg{
      width: 0px;
      height: 0px;
    }
    .canvas {
      margin: -8px;
      justify-self: center;
    }

    .quatro-out {
      background-color: var(--st-color);
      clip-path: url(#quatroOut);
      height: var(--st-height);
      position: absolute;
      width: var(--st-width);
      z-index: 30;
      background-image: var(--bg-background);
    }

    .quatro-inner{
      background-color: var(--st-color);
      clip-path: url(#qutro);
      height: var(--st-height);
      overflow: hidden;
      position: absolute;
      position: relative;
      width: var(--st-width)
    }
  `]
}

declare global {
  interface HTMLElementTagNameMap {
    'bg-quatro': BgQuatro
  }
}
